<sh-form-number-input
    *ngIf="profileField$ | async as profileField"
    [id]="profileField.FieldDefinition.FlatKey"
    [min]="0"
    [label]="profileField.DisplayLabel"
    [labelIcons]="labelIcons"
    [helpText]="profileField.Description"
    [control]="control$ | async"
    [errorMsg]="(errorMsg$ | async) || '' | translate"
    [canBeIndeterminate]="canBeIndeterminate"
    [indeterminateMsg]="'general.different-values' | translate"
    [title]="disabledMessageKey | translate"
>
    <ng-content></ng-content
></sh-form-number-input>
